/**
 * Maps ISO 639-3 language codes to appropriate Noto Sans font families
 * for non-Latin script languages. Returns undefined for Latin-script languages
 * (which use the default Inter font).
 */

const LANGUAGE_FONT_MAP: Record<string, string> = {
  ara: 'Noto Sans Arabic',
  asm: 'Noto Sans Bengali',
  ben: 'Noto Sans Bengali',
  zho: 'Noto Sans SC',
  guj: 'Noto Sans Gujarati',
  hin: 'Noto Sans Devanagari',
  jpn: 'Noto Sans JP',
  kan: 'Noto Sans Kannada',
  kor: 'Noto Sans KR',
  mal: 'Noto Sans Malayalam',
  mar: 'Noto Sans Devanagari',
  nep: 'Noto Sans Devanagari',
  ori: 'Noto Sans Oriya',
  pan: 'Noto Sans Gurmukhi',
  tam: 'Noto Sans Tamil',
  tel: 'Noto Sans Telugu',
  urd: 'Noto Nastaliq Urdu',
};

/**
 * Returns the appropriate font family for a given language code.
 * Returns undefined for Latin-script languages (default font should be used).
 */
export function getFontForLanguage(code: string): string | undefined {
  return LANGUAGE_FONT_MAP[code];
}
